import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDomainEnum,
	getPortfolioDomainProducersV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useProducersQuery = (
	domain: ClientPortfolioDomainEnum | undefined,
	categoryId?: number,
) => {
	return useQuery({
		queryKey: PortfolioKeys.producers(domain!, categoryId),
		queryFn: processResponse(() =>
			getPortfolioDomainProducersV2(domain!, categoryId),
		),
		enabled: Boolean(domain),
	});
};
